import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { connect } from 'react-redux';
import { libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import {
  selectLiteSuggestionsForCurrentUser,
  selectPremiumSuggestionsForCurrentUser
} from 'app/selectors/SuggestForPurchaseSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import SuggestForPurchaseButton from './SuggestForPurchaseButton';

export function SuggestForPurchaseButtonContainer(props) {
  return <SuggestForPurchaseButton {...props} />;
}

SuggestForPurchaseButtonContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  liteSuggestions: ImmutablePropTypes.list.isRequired,
  premiumSuggestions: ImmutablePropTypes.list.isRequired
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  liteSuggestions: selectLiteSuggestionsForCurrentUser(state),
  premiumSuggestions: selectPremiumSuggestionsForCurrentUser(state),
  user: selectCurrentUser(state)
});

export default connect(mapStateToProps)(SuggestForPurchaseButtonContainer);
